import React from "react";
import { Container, Typography } from "@mui/material";

function Nomatch() {
    return (
        <div>
            <Container
                maxWidth="1280"
                sx={{ display: { xs: { maxWidth: 0 } }, maxWidth: 1280 }}
            >
                <Typography
                    sx={{ mt: 10 }}
                    style={{ display: "flex", justifyContent: "center" }}
                >
                    404 Not Found
                </Typography>
            </Container>
        </div>
    );
}

export default Nomatch;
